export const PageText = {
  _1: 'Informative',
  _2: 'Boost digital signage or informative websites with regularly changing air quality content (real-time & forecast). Act first and integrate aircheckr into your service!',
  _3: 'Integrate aircheckr into your service',
  _4: 'People need to be informed in order to make better decisions and appropriate actions to breathe better air. Integrate aircheckr into your service now.'
};

export const Categories = {
  _1: {
    title: "Hot topic",
    subcategories: [
      {
        key: 0,
        subtitle: 'AQ changes regularly over time and space',
        text: 'Air quality data is a new and interesting news item for visitors, complementing e.g. traffic and weather information. As air quality changes regularly over time and space, it is an extra asset for people to visit the site again.'
      }
    ]
  },
  _2: {
    title: 'The aircheckr solution',
    subcategories: [
      {
        key: 0,
        subtitle: 'Attractive content',
        text: 'aircheckr gives the visitors a clear and attractive indication on the current air quality and a prognosis for the coming hours/days. We offer local (city level) air quality data, including additional information like recommendations. You can choose one of the aircheckr widgets or start from scratch with our handy API.'
      }
    ]
  }
};

export const Quotes = [{
  key: 0,
  text: 'Keeping digital signage content fresh is important if you want to keep your customers engaged and interested.',
  author: 'Dynamax'
},
{
  key: 1,
  text: 'Air quality changes regularly over time and space and is hence ideal content for websites or digital signage',
  author: 'Nicolas Dosselaere, nazka mapps'
}];

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/informative_page.js